import {visit} from 'unist-util-visit';
import type {Link, Parent, Root, Text} from 'mdast';

export function transformProblemLinks(): (tree: Root) => void {
    return (tree: Root) => {
        visit(tree, 'text', (node: Text, index, parent) => {
            if (!parent || index === undefined) return;
            const regex = /\[p#(\d+)\]/gi;
            const segments: (Text | Link)[] = [];
            let lastIndex = 0;
            let match;

            while ((match = regex.exec(node.value)) !== null) {
                const [raw, id] = match;
                const start = match.index;
                if (start > lastIndex) {
                    segments.push({
                        type: 'text',
                        value: node.value.slice(lastIndex, start),
                    } as Text);
                }
                segments.push({
                    type: 'link',
                    url: `/problems/${id}`,
                    title: null,
                    children: [{type: 'text', value: `#${id}`}],
                } as import('mdast').Link);
                lastIndex = start + raw.length;
            }

            if (lastIndex < node.value.length) {
                segments.push({
                    type: 'text',
                    value: node.value.slice(lastIndex),
                } as Text);
            }

            if (segments.length > 0) {
                (parent as Parent).children.splice(index, 1, ...segments);
            }
        });
    };
}
